export default __webpack_public_path__ + "static/media/invoice_payment_expense.a77b1e26.svg";